"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const framer_motion_1 = require("framer-motion");
const classnames_1 = __importDefault(require("classnames"));
const CloseIcon_1 = __importDefault(require("../../icons/CloseIcon"));
const useOnClickOutside_1 = __importDefault(require("../../hooks/useOnClickOutside"));
const useKeyPress_1 = __importDefault(require("../../hooks/useKeyPress"));
const modal_module_scss_1 = __importDefault(require("./modal.module.scss"));
const Modal = ({ className, children, title, isOpen, withInnerSpace = true, withCloseButton = true, fluid, onClose, preventCloseOnOutsideClick, preventCloseOnESC, size = 'container' }) => {
    const ref = (0, react_1.useRef)(null);
    (0, useOnClickOutside_1.default)(ref, () => {
        if (!preventCloseOnOutsideClick)
            onClose();
    });
    (0, useKeyPress_1.default)('Escape', () => {
        if (!preventCloseOnESC)
            onClose();
    });
    (0, react_1.useEffect)(() => {
        document.body.classList[isOpen ? 'add' : 'remove']('layer-is-open');
        return () => document.body.classList.remove('layer-is-open');
    }, [isOpen]);
    return ((0, jsx_runtime_1.jsx)(framer_motion_1.AnimatePresence, { children: isOpen && ((0, jsx_runtime_1.jsx)(framer_motion_1.motion.div, Object.assign({ className: (0, classnames_1.default)(className, modal_module_scss_1.default.modal, {
                [modal_module_scss_1.default.modal_fluid]: fluid
            }, modal_module_scss_1.default[`modal_${size}`]), variants: variants.modal }, baseMotionProps, { transition: transitionsProps.modal }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: modal_module_scss_1.default.modal_frame }, { children: (0, jsx_runtime_1.jsxs)(framer_motion_1.motion.div, Object.assign({ className: modal_module_scss_1.default.modal_content, ref: ref, variants: variants.content }, baseMotionProps, { transition: transitionsProps.content }, { children: [(title || withCloseButton) && ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: modal_module_scss_1.default.modal_header }, { children: [title && (0, jsx_runtime_1.jsx)("h3", Object.assign({ className: modal_module_scss_1.default.modal_title }, { children: title }), void 0), withCloseButton && ((0, jsx_runtime_1.jsx)("button", Object.assign({ type: "button", className: modal_module_scss_1.default.modal_close_btn, onClick: onClose }, { children: (0, jsx_runtime_1.jsx)(CloseIcon_1.default, {}, void 0) }), void 0))] }), void 0)), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, classnames_1.default)(modal_module_scss_1.default.modal_body, {
                                [modal_module_scss_1.default.modal_body_space]: withInnerSpace
                            }) }, { children: children }), void 0)] }), "modal-content") }), void 0) }), "modal")) }, void 0));
};
exports.default = Modal;
const variants = {
    modal: {
        hidden: {
            opacity: 0,
            transition: {
                when: 'afterChildren'
            }
        },
        visible: {
            opacity: 1,
            transition: {
                when: 'beforeChildren'
            }
        }
    },
    content: {
        hidden: { y: '-30%', opacity: 0 },
        visible: { y: 0, opacity: 1 }
    }
};
const baseMotionProps = {
    initial: 'hidden',
    animate: 'visible',
    exit: 'hidden'
};
const transitionsProps = {
    modal: {
        duration: 0.1,
        ease: 'easeInOut'
    },
    content: {
        duration: 0.2,
        ease: 'easeInOut'
    }
};
